import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon';

/**
 * Estado vazio.
 *
 * Base vazia e um estado normal de uma plataforma recem-instalada, e nao um erro.
 * A tela explica o que existe ali e oferece o proximo passo, em vez de exibir uma
 * area em branco que parece falha de carregamento.
 */
export function EmptyState({
  icon = 'layers',
  title,
  description,
  action,
}: {
  icon?: IconName | undefined;
  title: string;
  description?: string | undefined;
  action?: ReactNode | undefined;
}) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-14 text-center">
      <span className="flex size-12 items-center justify-center rounded-full bg-brand-50 text-brand-500">
        <Icon name={icon} size={22} />
      </span>
      <h3 className="mt-4 text-sm font-semibold text-ink-900">{title}</h3>
      {description ? (
        <p className="mt-1.5 max-w-sm text-sm text-ink-500">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
